import { Tabs } from 'antd';
import { useMatch } from 'react-router-dom';

import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';
import { RequestJobPostingId } from '../../types';
import styles from './RequestJobPostingTabs.module.css';

const RequestJobPostingTabs = () => {
  const { tenant, id } = useTypedParams({ tenant: String, id: RequestJobPostingId });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/request-job-postings/:id/:activeTabKey/*');

  const handleTabChange = (key: string) => {
    switch (key) {
      case 'analysis':
        navigate(
          { pathname: '/:tenant/request-job-postings/:id/analysis/', params: { tenant, id } },
          { replace: true }
        );
        break;
      case 'history':
        navigate(
          { pathname: '/:tenant/request-job-postings/:id/history/', params: { tenant, id } },
          { replace: true }
        );
        break;
    }
  };

  return (
    <>
      <Tabs
        activeKey={match?.params?.activeTabKey || 'analysis'}
        onChange={handleTabChange}
        className={styles.customTab}
        items={[
          { key: 'analysis', label: 'Analisar requisição' },
          { key: 'history', label: 'Histórico' },
        ]}
      />
    </>
  );
};

export default RequestJobPostingTabs;
